<template>
  <div>
    <!-- Кнопка открытия модального окна для создания экспертизы -->
    <v-btn class="btn-link" @click.native.stop="docsModal = true">
      <label :class="{ invalid: invalid }">{{ $t('Добавить экспертизу') }}</label>
    </v-btn>
    <v-dialog v-model="docsModal" max-width="600">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Экспертиза') }}
          <v-btn color="modal-close" @click.native="docsModal = false">
            <span class="pro-icon-close1"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <!-- Глобальные поля экспертизы -->
          <v-row>
            <v-col cols="12" sm="12" :class="{ invalid: $v.examination.name.$error }">
              <v-text-field :outlined="true" v-model="examination.name" label="Наименование экспертизы"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea rows="3" :outlined="true"  v-model="examination.comment" label="Комментарий экспертизы"></v-textarea>
            </v-col>
          </v-row>
          <!-- Блок для загрузки документов -->
          <div>
            <div v-for="(doc, index) in documentList" :key="index">
              <v-row>
                <v-col cols="6" sm="6" class="col-file-input" :class="{ invalid: $v.documentList && $v.documentList[index] && $v.documentList[index].file.$error }">
                  <v-file-input
                    :outlined="true"
                    v-model="doc.file"
                    label="Загрузить документ"
                  />
                </v-col>
                <v-col cols="6" sm="6" :class="{ invalid: $v.documentList && $v.documentList[index] && $v.documentList[index].name.$error }">
                  <v-text-field
                    :outlined="true"
                    v-model="doc.name"
                    label="Наименование документа">
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-btn color="secondary" @click="removeDocument(index)">
                    Удалить документ
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-btn color="primary" @click="addDocument">
              Добавить документ
            </v-btn>
          </div>
          <!-- Кнопка сохранения экспертизы -->
          <v-row>
            <v-col cols="12" sm="12">
              <v-btn color="primary" dark @click="submitExamination">
                Добавить экспертизу
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    examination: {
      name: '',
      comment: ''
    },
    documentList: [
      { file: null, name: '' }
    ],
    docsModal: false
  }),
  validations: {
    examination: {
      name: { required },
    },
    documentList: {
      $each: {
        name: { required },
        file: { required }
      }
    }
  },
  methods: {
    addDocument() {
      this.documentList.push({ file: null, name: '' });
    },
    removeDocument(index) {
      console.log(index)
      this.documentList.splice(index, 1);
    },
    submitExamination() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }
      const payload = {
        npa_examination_type: {
          name: this.examination.name,
          comment: this.examination.comment,
          documents: this.documentList
        }
      };
      this.$emit('setDataExaminations', payload);
      this.resetExamination();
      this.docsModal = false;
    },
    resetExamination() {
      this.examination = { name: '', comment: '' };
      this.documentList = [];
    }
  }
}
</script>

<style lang="scss">
.file-item {
  textarea {
    height: 100px;
    resize: none;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
}
</style>
